module.exports = __webpack_public_path__ + "img/Father.879f49d9.svg";